module.exports = __webpack_public_path__ + "img/tablet-02.23e05d42.svg";